<div class="package-details" [lxVisibility]="PACKAGE_DETAILS_CONTAINER_ID">
  <lx-card-container
    data-qa="packageDetails_card"
    i18n-title
    title="Your package"
    type="package-details"
    [plain]="(handheld$ | async) === false"
    *ngIf="packageDetails$ | async as packageDetails"
  >
    <div class="package-details__deposit" *ngIf="(activeFlow$ | async) !== Flows.Online">
      <div class="package-details__deposit__title" i18n>Secure deposit today</div>
      <div class="package-details__deposit__price">
        <span class="package-details__deposit__price__total">
          {{
            depositAmounts
              | lxPrice
                : {
                    currency: currency$ | async,
                    showCurrency: false,
                    minDecimalPlaces: decimalPlaces
                  }
          }}
        </span>
        <span class="package-details__deposit__price__currency">{{ currency$ | async }}</span>
      </div>

      <div class="package-details__deposit__prompt" *ngIf="depositMessage" i18n>
        Your departure is in less than {{ depositMessage }}! Please make your deposit payment
        <span class="package-details__deposit__prompt__emphasis">now</span> to ensure quick processing of your application.
      </div>
    </div>
    <div class="package-details__total">
      <div class="package-details__total__title" i18n>Total price</div>
      <span class="package-details__total__grand-price" [class.package-details__total__grand-price--online]="(activeFlow$ | async) === Flows.Online">
        {{
          packageDetails.grandTotal
            | lxPrice
              : {
                  currency: currency$ | async,
                  minDecimalPlaces: decimalPlaces,
                  showCurrency: false
                }
        }}
      </span>
      <span class="package-details__total__grand-currency" [class.package-details__total__grand-currency--online]="(activeFlow$ | async) === Flows.Online">{{
        currency$ | async
      }}</span>
      <span
        *ngIf="!(packageDetails.grandTotal | lxEqual : packageDetails.productTotal : [{ property: 'value' }])"
        class="package-details__total__products-price"
      >
        {{
          packageDetails.productTotal
            | lxPrice
              : {
                  currency: currency$ | async,
                  minDecimalPlaces: decimalPlaces
                }
        }}
      </span>
    </div>
    <div class="package-details__quote-breakdown" (click)="toggleBreakdown()">
      <div class="package-details__quote-breakdown__link" i18n data-qa="packageDetails_quoteBreakdown_link">
        <span tabindex="0" (keydown.enter)="toggleBreakdown()">Quote details</span>
      </div>
    </div>
  </lx-card-container>
</div>

<lx-side-panel
  i18n-title
  title="Your quote breakdown"
  [visible]="quoteBreakdownVisible$ | async"
  (hiddenPanel)="hideBreakdown()"
  data-qa="packageDetails_quoteBreakdown_sidePanel"
>
  <lx-quote-breakdown></lx-quote-breakdown>

  <div class="package-details__quote-breakdown-footer" ngProjectAs="footer">
    <lx-button
      i18n-text
      text="Back"
      [btnRounded]="true"
      tabindex="0"
      [block]="true"
      [buttonStyle]="'primary'"
      icon="pi pi-arrow-left"
      iconPos="before"
      (buttonClick)="hideBreakdown()"
      (buttonEnter)="hideBreakdown()"
      [class.package-details__quote-breakdown-footer__back-button--adult]="(activeFlow$ | async) !== Flows.Junior"
      [class.package-details__quote-breakdown-footer__back-button--junior]="(activeFlow$ | async) === Flows.Junior"
      data-qa="packageDetails_quoteBreakdown_backButton"
    >
    </lx-button>
  </div>
</lx-side-panel>
